import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import css from './courseComplete.module.css';
import Header from '../../components/standartComponents/header';

const ArrowSvg = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M5 12h14" />
        <path d="m12 5 7 7-7 7" />
    </svg>
);

const CourseComplete = ({ authUser }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <>
            <Header authUser={authUser} />
            <div className={css.wrap}>
                {/* HERO */}
                <div className={css.hero}>
                    <div className={css.sparkles}>
                        {[1,2,3,4,5,6].map(i => <div className={css.sp} key={i}></div>)}
                    </div>
                    <div className={css.sucIcon}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5C7 4 9 8 12 8s5-4 7.5-4a2.5 2.5 0 0 1 0 5H18" />
                            <path d="M12 8v13" />
                            <path d="M6 9v8a4 4 0 0 0 4 4h4a4 4 0 0 0 4-4V9" />
                        </svg>
                    </div>
                    <div className={css.levelBadge}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="m12 3-1.9 5.8a2 2 0 0 1-1.3 1.3L3 12l5.8 1.9a2 2 0 0 1 1.3 1.3L12 21l1.9-5.8a2 2 0 0 1 1.3-1.3L21 12l-5.8-1.9a2 2 0 0 1-1.3-1.3L12 3Z" />
                        </svg>
                        Travel English · A0 → A1
                    </div>
                    <h1>{t("Congratulations! Course completed")}</h1>
                    <p>{t("You successfully completed Travel English A0 → A1 and took a big step towards confident English.")}</p>
                    <p className={css.motto}>{t("This is not the end — it is a new level of your English.")}</p>
                </div>

                {/* STATS */}
                <div className={css.stats}>
                    <div className={css.stat}>
                        <div className={`${css.statIcon} ${css.si1}`}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg></div>
                        <div className={css.statVal}>18/18</div>
                        <div className={css.statLbl}>{t("Lessons")}</div>
                    </div>
                    <div className={css.stat}>
                        <div className={`${css.statIcon} ${css.si2}`}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"/></svg></div>
                        <div className={css.statVal}>142</div>
                        <div className={css.statLbl}>{t("Words learned")}</div>
                    </div>
                    <div className={css.stat}>
                        <div className={`${css.statIcon} ${css.si3}`}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m19 21-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16z"/></svg></div>
                        <div className={css.statVal}>47</div>
                        <div className={css.statLbl}>{t("In dictionary")}</div>
                    </div>
                    <div className={css.stat}>
                        <div className={`${css.statIcon} ${css.si4}`}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 12h-4l-3 9L9 3l-3 9H2"/></svg></div>
                        <div className={css.statVal}>86%</div>
                        <div className={css.statLbl}>{t("Average score")}</div>
                    </div>
                    <div className={css.stat}>
                        <div className={`${css.statIcon} ${css.si5}`}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3Z"/><path d="M19 10v2a7 7 0 0 1-14 0v-2"/></svg></div>
                        <div className={css.statVal}>12</div>
                        <div className={css.statLbl}>{t("Dialogues")}</div>
                    </div>
                    <div className={css.stat}>
                        <div className={`${css.statIcon} ${css.si6}`}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/></svg></div>
                        <div className={css.statVal}>21</div>
                        <div className={css.statLbl}>{t("Days")}</div>
                    </div>
                </div>

                {/* NEXT STEPS */}
                <div className={css.nextSection}>
                    <div className={css.secTitle}>{t("What next?")}</div>
                    <div className={css.nextGrid}>
                        <div className={`${css.nextCard} ${css.primaryCard}`} onClick={() => navigate('/create-course')}>
                            <div className={`${css.ncIcon} ${css.nci1}`}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m18 15-6-6-6 6"/></svg></div>
                            <h3>{t("Raise level")}</h3>
                            <p className={css.ncDesc}>{t("Continue Travel English at A1 → A2. New topics, vocabulary, and speaking.")}</p>
                            <button className={`${css.ncCta} ${css.ncCtaP}`}>
                                {t("Start A1 → A2")}<ArrowSvg />
                            </button>
                        </div>
                        <div className={css.nextCard} onClick={() => navigate('/create-course')}>
                            <div className={`${css.ncIcon} ${css.nci2}`}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m12 3-1.9 5.8a2 2 0 0 1-1.3 1.3L3 12l5.8 1.9a2 2 0 0 1 1.3 1.3L12 21l1.9-5.8a2 2 0 0 1 1.3-1.3L21 12l-5.8-1.9a2 2 0 0 1-1.3-1.3L12 3Z"/></svg></div>
                            <h3>{t("Learn a new topic")}</h3>
                            <p className={css.ncDesc}>{t("Choose another area: work, study, socializing, or something new.")}</p>
                            <button className={`${css.ncCta} ${css.ncCtaS}`}>
                                {t("Choose a topic")}<ArrowSvg />
                            </button>
                        </div>
                        <div className={css.nextCard} onClick={() => navigate('/allvideos')}>
                            <div className={`${css.ncIcon} ${css.nci3}`}><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="5 3 19 12 5 21 5 3"/></svg></div>
                            <h3>{t("Watch something interesting")}</h3>
                            <p className={css.ncDesc}>{t("Browse videos on different topics and practice without a plan at your own pace.")}</p>
                            <button className={`${css.ncCta} ${css.ncCtaS}`}>
                                {t("Choose a video")}<ArrowSvg />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CourseComplete;